var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCaretDropdown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 5,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#212529",
  d: "M3.3 4.3.7 1.7Q.225 1.225.488.613.75 0 1.425 0h5.15q.675 0 .937.613.263.612-.212 1.087L4.7 4.3q-.15.15-.325.225A.9.9 0 0 1 4 4.6a.9.9 0 0 1-.375-.075A1 1 0 0 1 3.3 4.3"
})));
export { SvgCaretDropdown as ReactComponent };
export default __webpack_public_path__ + "static/media/caret-dropdown.8289b661.svg";